import type { IdFileInfoDto } from '@/services/ws-file-uploader/src/main/resources/rest-api';
import { downloadFileWithAccessCheck } from '@/services/ws-file-uploader/src/main/resources/rest-api';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { useSubscribe } from '@/js/libs/observable';
import { useLazyRequest } from '@/js/libs/use-request';

import { useSaveFileResponse } from './useSaveFileResponse.ts';

type UseDownloadFile = () => {
  downloadFile: (fileId: IdFileInfoDto, name?: string) => Promise<void>;
  pendingDownloadFile: boolean;
};

export const useDownloadFile: UseDownloadFile = () => {
  const saveFile = useSaveFileResponse();

  const downloadRequest = useLazyRequest({
    apiMethod: downloadFileWithAccessCheck,
    cancelPreviousRequests: false,
  });

  const pendingDownloadFile = useSubscribe(downloadRequest.pending$);

  const download = useCallbackRef(async (fileId: IdFileInfoDto, name?: string) => {
    saveFile(await downloadRequest.load({ fileId }), name);
  });

  return { downloadFile: download, pendingDownloadFile };
};
